import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import React from 'react';
import { useScrollDispatch } from '../../../../contexts';

import './GoToTicketsButton.scss';

export const GoToTicketsButton = () => {
    const scrollTo = useScrollDispatch();

    return (
        <div className="GoToTicketButton__container">
            <Button
                onClick={() =>
                    scrollTo({ action: 'scroll', target: 'tickets' })
                }
                variant="primary"
                size="block"
                aria-label={gettext('Get tickets')}
            >
                {gettext('Get tickets')}
            </Button>
        </div>
    );
};
